// import { IReduxState } from '../app/types';
import { POLL_TYPE } from './constants';
/**
 * Selector creator for determining if poll results should be displayed or not.
 *
 * @param {string} id - Id of the poll.
 * @returns {Function}
 */
export function shouldShowResults(id) {
    return function (state) {
        var _a;
        return Boolean((_a = state['features/polls']) === null || _a === void 0 ? void 0 : _a.polls[id].showResults);
    };
}
/**
 * Selector creator for polls.
 *
 * @param {string} pollId - Id of the poll to get.
 * @returns {Function}
 */
export function getPoll(pollId) {
    return function (state) {
        return state['features/polls'].polls[pollId];
    };
}
/**
 * Selector for calculating the number of unread poll messages.
 *
 * @param {IReduxState} state - The redux state.
 * @returns {number} The number of unread messages.
 */
export function getUnreadPollCount(state) {
    const { nbUnreadPolls } = state['features/polls'];
    return nbUnreadPolls;
}
/**
 * Determines if the submit poll answer button should be disabled.
 *
 * @param {Array<boolean>} checkBoxStates - The states of the checkboxes.
 * @param {string} pollType - The type of poll (single-select or multi-select).
 * @returns {boolean}
 */
export function isSubmitAnswerDisabled(checkBoxStates, pollType) {
    const selectedCount = checkBoxStates.filter(checked => checked).length;
    if (pollType === POLL_TYPE.SINGLE_SELECT) {
        // For single-select polls, exactly one option must be selected
        return selectedCount !== 1;
    }
    // For multi-select polls (default), at least one option must be selected
    return selectedCount === 0;
}
